import MilestonesAdapter from './base';

export default class Expectation extends MilestonesAdapter {
  modelNamePlural = 'expectations';
}
